export interface IAnalyticsData {
    event_category?: string;
    event_label?: string;
    value?: string;
}

export const trackEvent = (eventName: string, data?: IAnalyticsData) => {
    typeof window !== "undefined" && window.gtag && window.gtag("event", eventName, { ...data })
}
